import setupConsent from "./setupConsent";
import scriptLoader from "./scriptLoader";
import setPublisherId from "./setPublisherId";

const ensurePageSetup = async ({
  scriptSrc,
  fetchMarginPercent,
  renderMarginPercent,
  mobileMarginScaling,
  hashedCustomerIdPromise,
}) => {
  if (!window.googletag?.cmd) {
    // Google's own ad library (or site chrome) may have already set window.googletag without a cmd queue
    window.googletag = window.googletag || {};
    window.googletag.cmd = [];
    const hashedCustomerId = await hashedCustomerIdPromise;

    window.googletag.cmd.unshift(() => {
      window.googletag.pubads().setForceSafeFrame(true).collapseEmptyDivs(true);
      window.googletag.pubads().enableLazyLoad({
        fetchMarginPercent,
        renderMarginPercent,
        mobileScaling: mobileMarginScaling,
      });
      setupConsent();
      setPublisherId(hashedCustomerId);
    });
    scriptLoader({ scriptSrc });
  }
};

export default ensurePageSetup;
